import { css } from '@microsoft/fast-element';
import { MainStyles } from '../../../../main/main.styles';

export const IndividualProjectVppasGridStyles = css`
  ${MainStyles}

  .grid-styles {
    width: 100%;
    height: 365px;
  }
`;
